import { render, staticRenderFns } from "./addRegional.vue?vue&type=template&id=b9cda68e&scoped=true"
import script from "./addRegional.vue?vue&type=script&lang=js"
export * from "./addRegional.vue?vue&type=script&lang=js"
import style0 from "./addRegional.vue?vue&type=style&index=0&id=b9cda68e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9cda68e",
  null
  
)

export default component.exports